import dayjs, { Dayjs } from "dayjs";
import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetSlotRequestsProps } from "@/services/slot-requests.service";

export interface SRFRProps {
  slot_request_date?: Dayjs;
  account_number?: Option;
  grain: number;
  estados?: number[];
  origin?: string;
  direct_slots?: number;
  plant_slots?: number;
}

export const getSlotRequestsFilter = (
  event: SRFRProps,
): Partial<GetSlotRequestsProps> => {
  return {
    ...(event?.slot_request_date && dayjs(event?.slot_request_date).isValid()
      ? {
          fecha: dayjs(event?.slot_request_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
    ...(event?.account_number?.value
      ? {
          nroCuenta: String(event?.account_number?.value),
        }
      : {}),
    ...(event.grain
      ? {
          grano: event?.grain,
        }
      : {}),
    ...(event.origin
      ? {
          procedencia: event?.origin,
        }
      : {}),
    ...(event?.direct_slots
      ? {
          cuposDirectos: event?.direct_slots,
        }
      : {}),
    ...(event?.plant_slots
      ? {
          cuposAPlanta: event?.plant_slots,
        }
      : {}),
  };
};
